
interface FooterProps {
  scrollToSection: (id: string) => void;
}

export default function Footer({ scrollToSection }: FooterProps) {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/9351db98-9473-4ed8-9f5c-c80587259950.png" 
              alt="LACOJEC LTDA Logo" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Leading technology company specializing in VPN solutions and digital security applications.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('home')}
                  className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  About
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('faq')}
                  className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>
                <a href="tel:+17408727749" className="hover:text-teal-400 transition-colors cursor-pointer">
                  +1 7408727749
                </a>
              </li>
              <li>
                <a href="mailto:contact@lacojecltda.com" className="hover:text-teal-400 transition-colors cursor-pointer">
                  contact@lacojecltda.com
                </a>
              </li>
              <li className="pt-2">
                <strong className="text-white">Location</strong>
              </li>
              <li>CALLE 74 56 36 OF 805</li>
              <li>BARRANQUILLA, Colombia</li>
              <li>080003</li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-lg font-semibold mb-4">LACOJEC LTDA</h4>
            <p className="text-gray-400 text-sm leading-relaxed">
              Committed to providing cutting-edge VPN solutions with enterprise-level security and privacy protection.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-4">
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-fill text-xl"></i>
              </a>
            </div>
            
            <p className="text-gray-400 text-sm text-center">
              © 2025 LACOJEC LTDA. All rights reserved.
            </p>
            
            <div className="flex items-center gap-4">
              <button 
                onClick={() => scrollToSection('terms')}
                className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer whitespace-nowrap"
              >
                Terms of Service
              </button>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer whitespace-nowrap"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
